/**
 * Theme Initialization Scripts
 * Consolidated inline scripts for better performance
 */

// Back to Top Button
function initBackToTop() {
  const backToTopBtn = document.getElementById('back-to-top');
  if (!backToTopBtn) return;

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 700) {
      backToTopBtn.classList.add('show');
    } else {
      backToTopBtn.classList.remove('show');
    }
  });

  backToTopBtn.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

// Swiper Lazy Loading and Initialization
let swiperLoaded = false;
function loadSwiper() {
  if (swiperLoaded) return Promise.resolve();

  return new Promise((resolve) => {
    if (typeof Swiper !== 'undefined') {
      swiperLoaded = true;
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = window.swiperAssetUrl;
    script.onload = () => {
      swiperLoaded = true;
      resolve();
    };
    script.onerror = () => {
      console.error('Failed to load Swiper from assets');
      resolve();
    };
    document.body.appendChild(script);
  });
}

// Swiper Initialization
function initSwiper() {
  const swiperContainers = document.querySelectorAll('.swiper-container');
  if (swiperContainers.length === 0) return;

  loadSwiper().then(() => {
    swiperContainers.forEach(container => {
      if (container.swiper) return;

      new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  });
}

// Lazy load Swiper when containers are in viewport
function lazyLoadSwiper() {
  const swiperContainers = document.querySelectorAll('.swiper-container');
  if (swiperContainers.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        initSwiper();
        observer.disconnect();
      }
    });
  }, { rootMargin: '50px' });

  swiperContainers.forEach(container => observer.observe(container));
}

// Grid Toggle Buttons
function initGridToggle() {
  const buttons = document.querySelectorAll('.grid-btn');
  const grid = document.getElementById('productGrid');
  if (!grid) return;

  buttons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      grid.classList.remove('grid-cols-1', 'grid-cols-2', 'grid-cols-3', 'grid-cols-4', 'grid-cols-5');
      buttons.forEach(btn => btn.classList.remove('active'));
      const cols = this.getAttribute('data-columns');
      grid.classList.add('grid-cols-' + cols);
      this.classList.add('active');
    });
  });
}

// Accordion
function initAccordion() {
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const parent = header.parentElement;
      const isOpen = parent.classList.contains('open');

      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('open');
        const toggle = item.querySelector('.accordion-toggle');
        if (toggle) toggle.textContent = '+';
      });

      if (!isOpen) {
        parent.classList.add('open');
        const toggle = parent.querySelector('.accordion-toggle');
        if (toggle) toggle.textContent = '–';
      }
    });
  });
}

// Wishlist Icon Update
function delay(ms) {
  return new Promise(res => setTimeout(res, ms));
}

window.updateWishlistIcon = async () => {
  const wishlistItems = localStorage.getItem("st-wishlist-local");
  const wishlistCount = wishlistItems ? JSON.parse(wishlistItems).length : 0;
  
  const counters = document.querySelectorAll(".wishlist-counter");
  counters.forEach(counter => {
    counter.innerHTML = wishlistCount;
  });
};

// Intercept localStorage.setItem to get live feedback when the wishlist updates
const originalSetItem = localStorage.setItem;
localStorage.setItem = function(key, value) {
  originalSetItem.apply(this, arguments);
  if (key === 'st-wishlist-local') {
    if (typeof window.updateWishlistIcon === 'function') {
      window.updateWishlistIcon();
    }
  }
};

// Cart Item Remove
function initCartRemove() {
  const removeButtons = document.querySelectorAll(".remove-item-button");
  removeButtons.forEach(button => {
    button.addEventListener("click", function() {
      const lineItemKey = this.getAttribute("data-line-key");

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      })
      .then(res => res.json())
      .then(cart => {
        const itemElement = document.querySelector(`[data-key="${lineItemKey}"]`);
        if (itemElement) {
          itemElement.remove();
        }
      })
      .catch(err => {
        console.error("Failed to remove item from cart:", err);
      });
    });
  });
}

// Initialize everything on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  initBackToTop();
  initGridToggle();
  initAccordion();
  window.updateWishlistIcon();
  initCartRemove();
  lazyLoadSwiper();
});